import React from "react";
import { PillarArticleModel } from "../../models/PillarModel";
import StoriesStore from "../../stores/StoriesStore";
import { Video } from "./Video";
import {
  ContentArticleImagePath,
  ContentArticleVideoPath,
} from "../../utils/ContentMediaPath";
import ImgLazyLoad from "../ImgLazyLoad";

interface PillarArticleProps {
  article: PillarArticleModel;
  animationDelay: number;
  isFirstPage: boolean;
}

interface PillarArticleState {
  animate: boolean;
}

export default class PillarArticle extends React.Component<
  PillarArticleProps,
  PillarArticleState
> {
  animationTimeout;

  constructor(props: PillarArticleProps) {
    super(props);

    this.state = {
      animate: props.animationDelay > 1000 ? true : false, //If more than 1000ms (10items) delay lets just show it
    };

    this.articleText = this.articleText.bind(this);
  }

  componentDidMount() {
    const { animate } = this.state;
    const { animationDelay } = this.props;

    if (!animate) {
      this.animationTimeout = setTimeout(() => {
        this.setState({ animate: true });
      }, animationDelay);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.animationTimeout);
  }

  articleText(): string {
    let text = this.props.article.text;
    text = text.replace(/®/g, "<sup>&reg;</sup>");
    text = text.replace(/™/g, "<sup>&trade;</sup>");

    return text;
  }

  render() {
    const { article, isFirstPage } = this.props;
    const { title, videoUrl, imageUrl, text } = article;
    const { animate } = this.state;

    return (
      <article
        className={`pillarArticle ${animate ? "pillarArticle--animate" : ""} ${
          !isFirstPage ? "pillarArticle--immediate" : ""
        }`}
      >
        {videoUrl && (
          <Video
            className="pillarArticle__video"
            source={ContentArticleVideoPath(videoUrl)}
            poster={imageUrl && ContentArticleImagePath(imageUrl)}
          />
        )}
        {imageUrl && !videoUrl ? (
          <ImgLazyLoad
            className="pillarArticle__image"
            src={ContentArticleImagePath(imageUrl)}
          />
        ) : null}
        {text || title ? (
          <div className="pillarArticle__textWrap">
            {title && <h1 className="pillarArticle__title">{title}</h1>}
            {text && (
              <p
                className="pillarArticle__text"
                dangerouslySetInnerHTML={{ __html: this.articleText() }}
              ></p>
            )}
          </div>
        ) : null}
      </article>
    );
  }
}
